module.exports = __webpack_public_path__ + "src/img/xinmeiti.cb04e4fc.svg";